import React from 'react';

// ════════════════════════════════════════════════════════════════
// Breathing Room studio attribution
// Shown next to "Book a Session" CTAs across the site.
//
// 👉 To REMOVE this from the entire site (e.g. if no longer
//    based at Breathing Room), do ONE of the following:
//      a) Set ENABLED = false below   (keeps file/imports intact)
//      b) Delete this file entirely    (and remove imports — search
//         the codebase for `BreathingRoomAttribution`)
// ════════════════════════════════════════════════════════════════

const ENABLED = true;

const BREATHING_ROOM_URL = 'https://breathingroombda.com/';
const BREATHING_ROOM_LOGO =
  'https://customer-assets-v7afamib.emergentagent.net/job_9cc27ad2-9473-4d8d-951e-838ca155566b/artifacts/8c8pod8j_cropped-1.-BR_Logo_MainColour.webp';

const BreathingRoomAttribution = ({
  align = 'left',
  theme = 'light', // 'light' for cream backgrounds, 'dark' for forest backgrounds
  className = '',
}) => {
  if (!ENABLED) return null;

  const alignClass =
    align === 'center'
      ? 'justify-center text-center'
      : align === 'right'
      ? 'justify-end text-right'
      : 'justify-start text-left';

  // Color palette by theme
  const isDark = theme === 'dark';
  const textColor = isDark ? 'text-cream/85' : 'text-stone-500';

  return (
    <div
      className={`flex items-center flex-wrap gap-x-3 gap-y-1 ${alignClass} ${className}`}
      data-testid="breathing-room-attribution"
    >
      <p className={`font-body text-xs sm:text-sm italic ${textColor} leading-snug`}>
        Currently sharing services through
      </p>
      <a
        href={BREATHING_ROOM_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Visit Breathing Room"
        className="inline-flex items-center rounded-md hover:opacity-80 transition-opacity"
      >
        <img
          src={BREATHING_ROOM_LOGO}
          alt="Breathing Room"
          className="h-9 sm:h-12 w-auto object-contain"
        />
      </a>
    </div>
  );
};

export default BreathingRoomAttribution;
